import { fetchRequest } from './apiHelper';

const POLL_INTERVAL_MS = 1000;
export const MAX_POLL_ATTEMPTS = 30;

const parseResult = (result) => {
  try {
    return JSON.parse(result);
  } catch {
    return null;
  }
};

const roundScore = (score) => {
  const roundedRank = Math.floor(score * 10) / 10;
  return score - roundedRank >= 0.05 ? roundedRank + 0.1 : roundedRank;
};

export const queryResult = (job_id, apiServer, setResult, attempt = 0) => {
  const url = `${apiServer}/smr_results/${job_id}.json`;
  const fail = (error_message) => setResult({ status: 'error', error_message });

  fetchRequest(url)
    .then((data) => {
      if (data.status === 'pending') {
        if (attempt >= MAX_POLL_ATTEMPTS) {
          fail(I18n.t('euro_smr_score_widget.error.timeout'));
          return;
        }
        setResult(data);
        setTimeout(
          () => queryResult(job_id, apiServer, setResult, attempt + 1),
          POLL_INTERVAL_MS
        );
        return;
      }

      const parsed = parseResult(data.result);

      if (data.status === 'completed' && parsed) {
        const score = parsed.calculated_score;
        if (typeof score !== 'number' || isNaN(score)) {
          fail(parsed.error_message);
          return;
        }

        setResult({
          status: 'completed',
          calculated_score: roundScore(score),
          score_type: parsed.score_type,
          risk_1yr_mortality: parsed.risk_1yr_mortality,
          risk_1yr_mortality_or_nyha_ge_iii:
            parsed.risk_1yr_mortality_or_nyha_ge_iii,
          risk_1yr_mortality_or_nyha_iv: parsed.risk_1yr_mortality_or_nyha_iv,
        });
        return;
      }

      fail(parsed?.error_message);
    })
    .catch(() => fail());
};
